export default __webpack_public_path__ + "static/media/all-white.38ebe682.png";